module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.propsNumeroProjeto ? '' : 'box',
    attrs: {
      "id": "gestao_atividades"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.carregando),
      expression: "loading.carregando"
    }],
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando barras de tempo das atividades...")]), _vm._v(" "), (!_vm.propsNumeroProjeto) ? _c('div', {
    staticClass: "box-header"
  }, [(_vm.listaProjetos.length > 1) ? _c('span', [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.numeroProjetoSelecionado),
      expression: "configuracoes.numeroProjetoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.configuracoes, "numeroProjetoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selecionaProjeto]
    }
  }, _vm._l((_vm.listaProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.ds_codigo_projeto_erp,
        "selected": projeto.ds_codigo_projeto_erp === _vm.configuracoes.numeroProjetoSelecionado
      }
    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome) + " ("), _c('b', [_vm._v(_vm._s(projeto.ds_situacao_erp))]), _vm._v(")")])
  }), 0)])])])]) : (_vm.listaProjetos.length === 1) ? _c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.listaProjetos[0].numero) + " - " + _vm._s(_vm.listaProjetos[0].nome))])]) : _c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Carregando projeto(s) ...")])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto)) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.processando),
      expression: "loading.processando"
    }],
    staticClass: "overlay",
    staticStyle: {
      "z-index": "2000",
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (!_vm.loading.carregando) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    attrs: {
      "id": "gantt"
    }
  }, [_c('div', {
    style: ('height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + (58 + 30) + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;'),
    attrs: {
      "id": "secao_gantt"
    }
  }, [(_vm.configuracoes.mostrarGrade) ? _c('div', {
    style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
      'width: ' + ((_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 150) + 'px;' +
      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30) + 'px;'),
    attrs: {
      "id": "grade_meses"
    }
  }, [(_vm.configuracoes.mostrarHoje && _vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) <= (_vm.projeto.periodos + 1)) ? _c('div', {
    ref: "HOJE",
    staticClass: "linha_hoje",
    style: ('margin-left: ' + (((_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) - 1) * _vm.configuracoes.larguraPadrao) + ((_vm.configuracoes.larguraPadrao * _vm.hoje.getDate()) / 30)) + 'px;' +
      'height:' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 20 + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px')
  }, [_c('i', {
    staticClass: "fa fa-sun-o"
  }), _vm._v(" Hoje\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projeto.periodos), function(p) {
    return _c('div', {
      staticClass: "periodo_mes",
      style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
        'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30 + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;' +
        'margin-left: ' + ((p - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        (p === 1 ? 'border-left: 1px solid var(--cor-borda);' : ''))
    }, [(_vm.configuracoes.mostrarGanttPorMes && (_vm.pendenciasPorPeriodo(p)).length > 0 && !_vm.modoEdicao) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: false,
          duration: 0,
          animation: 'fade',
          size: 'large',
          arrow: true,
          theme: 'light',
          placement: 'bottom',
          followCursor: true,
          distance: 40
        }),
        expression: "{inertia: false, duration: 0, animation: 'fade', size: 'large', arrow: true, theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
      }],
      staticClass: "periodo_mes_selecionado",
      attrs: {
        "title": '<h5>Previsto para <b>' + _vm.periodoParaMesAno(p, _vm.projeto.inicio, 'MMMM/YYYY') + '</b>' +
          '<hr/>' +
          _vm.exibirInformacaoSeHouver('Mandato', 'Mandatos', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
            return m.grupo === 'Mandato' ? 1 : 0
          })) +
          _vm.exibirInformacaoSeHouver('Relatório de Execução', 'Relatórios de Execução', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
            return m.grupo === 'Relatório de Execução' ? 1 : 0
          })) +
          _vm.exibirInformacaoSeHouver('Item do Orçamento previsto', 'Itens do Orçamento previstos', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
            return m.grupo === 'Item Orçamento' ? 1 : 0
          })) +

          '<hr/>' +
          _vm.exibirInformacaoSeHouver('Orçado', 'Orçado', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
            return m.grupo === 'Item Orçamento' ? parseFloat(m.info3) : 0
          })) +
          _vm.exibirInformacaoSeHouver('Executado', 'Executado', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
            return m.grupo === 'Item Orçamento' ? parseFloat(m.info4) : 0
          })) +
          '</h5>'
      },
      on: {
        "click": function($event) {
          _vm.mostrarPendenciaAnoMes(_vm.periodoParaMesAno(p, _vm.projeto.inicio, 'YYYY'), _vm.periodoParaMesAno(p, _vm.projeto.inicio, 'MM - MMMM'))
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
        (_vm.configuracoes.mostrarGanttPorMes && (_vm.pendenciasPorPeriodo(p)).length > 0 ? 'font-weight: bold;' : ''))
    }, [_vm._v("\n                    " + _vm._s(p) + "\n                  ")])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.configuracoes.mostrarRecursoMensal), function(origem) {
    return (_vm.configuracoes.mostrarOrcadoMensal) ? _c('div', [(_vm.propsAtividades && !_vm._.isEmpty(_vm.periodosOrcamento) && true) ? _c('div', {
      style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
        'width: ' + ((_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 150) + 'px;' +
        'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30) + 'px;' +
        'position: absolute; z-index: 1000; top: 20px;')
    }, _vm._l((_vm.projeto.periodos), function(p) {
      return _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: false,
            arrow: true,
            duration: 0,
            animation: 'fade',
            size: 'large',
            theme: 'light',
            placement: 'top',
            distance: 10
          }),
          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'top', distance: 10}"
        }],
        class: 'recurso_' + origem + '_mes',
        style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
          'height: ' + (parseInt(((_vm._.get(_vm.periodosOrcamento, [origem, p], 0) * (_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) / _vm._.max(_vm._.get(_vm.periodosOrcamento, [origem], 0))))) + 'px;' +
          'margin-left: ' + ((p - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
          (p === 1 ? 'border-left: 1px solid var(--cor-borda);' : '')),
        attrs: {
          "title": '<h5>R$ ' + (parseInt(_vm._.get(_vm.periodosOrcamento, [origem, p], 0) / 1000)) + ' mil</h5>'
        }
      })
    }), 0) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    style: ('width: ' + (_vm.configuracoes.larguraCabecalho) + 'px;' +
      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;'),
    attrs: {
      "id": "cabecalho_atividades"
    }
  }, _vm._l((_vm.atividades), function(atividade) {
    return _c('div', {
      staticClass: "nome_atividade truncar",
      style: ('height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
        (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
        'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
        'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;')
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: false,
          arrow: true,
          duration: 0,
          animation: 'fade',
          size: 'large',
          theme: 'light',
          placement: 'bottom',
          followCursor: true,
          distance: 40
        }),
        expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
      }],
      style: ('margin-bottom: ' + (_vm.configuracoes.altura / 4) + 'px;'),
      attrs: {
        "title": '<h5>' + atividade.descricao + '</h5>'
      }
    }, [_vm._v("\n                    " + _vm._s(atividade.descricao) + "\n                  ")]), _vm._v(" "), _vm._l((atividade.itens), function(item) {
      return (atividade.expandir) ? _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: false,
            arrow: true,
            duration: 0,
            animation: 'fade',
            size: 'large',
            theme: 'light',
            placement: 'bottom',
            followCursor: true,
            distance: 40
          }),
          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
        }],
        staticClass: "nome_item_despesa truncar",
        style: ('height: ' + (_vm.configuracoes.altura) + 'px;' +
          (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
          'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
          'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;'),
        attrs: {
          "title": '<h5>' + item.fk_itens + '<br/>' + item.observacao + '</h5>'
        }
      }, [(_vm._.includes(('' + item.id), 'novo')) ? _c('span', {
        staticClass: "label label-info"
      }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), _c('span', {
        style: ((!_vm._.includes(('' + item.id), 'novo') ? 'margin-left: 35px;' : '') + (_vm._.get(_vm.itemAtividadeEditando, 'id', 0) === item.id ? 'color: red' : ''))
      }, [_vm._v(_vm._s(item.fk_itens) + " - " + _vm._s(item.observacao))])]) : _vm._e()
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
      'width: ' + (_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 'px;' +
      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px'),
    attrs: {
      "id": "grafico_gantt"
    }
  }, _vm._l((_vm.atividades), function(atividade) {
    return _c('div', {
      staticClass: "atividade_projeto",
      style: ('height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
        'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;')
    }, [(!atividade.expandir) ? _c('div', {
      staticClass: "barra_execucao",
      style: ('width: ' + (
          ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) *
          (atividade.executado / atividade.orcado)
        ) + 'px;' +
        'height: ' + (_vm.configuracoes.altura) + 'px;' +
        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
    }) : _vm._e(), _vm._v(" "), (!atividade.expandir) ? _c('div', {
      staticClass: "barra_orcado",
      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        'height: ' + (_vm.configuracoes.altura) + 'px;' +
        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        (atividade.orcado > 0 && _vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > atividade.termino && _vm.percentual(atividade.executado, atividade.orcado) < 100 ? 'background: #ffc8c8;' : ''))
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "info_externo",
      style: ('margin-left: ' + ((atividade.termino) * _vm.configuracoes.larguraPadrao) + 'px;' +
        (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
        'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;')
    }, [(_vm.modoEdicao) ? _c('span', [(false) ? _c('span', {
      staticClass: "botao_acao_desfazer",
      on: {
        "click": function($event) {
          return _vm.reverterAlteracaoAtividade(atividade.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh"
    }), _vm._v("\n                          " + _vm._s(_vm.verificaAlteracaoPeriodoAtividadeItem(atividade.id)) + "\n                        ")]) : _vm._e()]) : (_vm.configuracoes.mostrarInfoExterno) ? _c('span', [_vm._v("\n                      " + _vm._s(atividade.orcado > 0 ? _vm.percentual(atividade.executado, atividade.orcado) + '%' : '') + "\n                    ")]) : _vm._e()]), _vm._v(" "), (!atividade.expandir) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: false,
          arrow: true,
          duration: 0,
          animation: 'fade',
          size: 'large',
          theme: 'light',
          placement: 'bottom',
          followCursor: true,
          distance: 40
        }),
        expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
      }],
      staticClass: "barra_atividade",
      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        'height: ' + (_vm.configuracoes.altura) + 'px;' +
        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        (_vm.modoEdicao && !atividade.expandir && _vm._.find(_vm.atividades, ['expandir', true]) ? 'background: rgba(255, 255, 255, 0.75);' : '') +
        (_vm.modoEdicao ? 'cursor: pointer;' : '')),
      attrs: {
        "title": '<h5>' + atividade.descricao + '<br/>' +
          (atividade.orcado > 0 ?
            '<hr/>' +
            'Orçado <b>' + (_vm.moeda(atividade.orcado)) + '</b><br/><br/>' +
            'Executado <b>' + (_vm.moeda(atividade.executado)) + '</b><br/><br/>' +
            '% liberado de <b>' + (_vm.percentual(atividade.executado, atividade.orcado)) + '%</b>' : '') +
          '</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.expandirAtividade(atividade)
        }
      }
    }) : _vm._e(), _vm._v(" "), (atividade.expandir) ? _c('div', {
      staticClass: "barra_detalhamento",
      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        'height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        (_vm.modoEdicao ? 'cursor: pointer;' : '')),
      on: {
        "click": function($event) {
          return _vm.expandirAtividade(atividade)
        }
      }
    }, [_c('div', {
      staticClass: "barra_grafico_totais_periodo",
      style: ('height: ' + _vm.configuracoes.altura + 'px;')
    }, _vm._l((_vm._.range(atividade.inicio, atividade.termino + 1)), function(ctp) {
      return _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: false,
            arrow: true,
            duration: 0,
            animation: 'fade',
            size: 'large',
            theme: 'light',
            placement: 'bottom',
            followCursor: true,
            distance: 40
          }),
          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
        }],
        staticClass: "coluna_totais_periodo",
        style: ('width: ' + _vm.configuracoes.larguraPadrao + 'px;' +
          'height: ' + _vm.configuracoes.altura + 'px;'),
        attrs: {
          "title": '<h5>Período <b>' + ctp + '</b> ( ' + _vm.periodoParaMesAno(ctp, _vm.projeto.inicio, 'MMMM/YYYY') + ' )<br/><br/>' +
            (_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) === 0 ? '' : 'Recursos FBB <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 1], 0))) + '</b><br/><br/>') +
            (_vm._.get(atividade, ['mensalizacao', ctp, 2], 0) === 0 ? '' : 'Contrapartida <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 2], 0))) + '</b><br/><br/>') +
            (_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) > 0 && _vm._.get(atividade, ['mensalizacao', ctp, 2], 0) > 0 ? 'Total <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 0], 0))) + '</b>' : '') +
            '</h5>'
        }
      }, [_c('div', {
        staticClass: "acumulado_periodo_contrapartida",
        style: ('height: ' + (Math.ceil(Math.abs((_vm._.get(atividade, ['mensalizacao', ctp, 2], 0) / atividade.orcado) * _vm.configuracoes.altura))) + 'px;')
      }), _vm._v(" "), _c('div', {
        staticClass: "acumulado_periodo_fbb",
        style: ('height: ' + (Math.ceil(Math.abs((_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) / atividade.orcado) * _vm.configuracoes.altura))) + 'px;')
      })])
    }), 0)]) : _vm._e(), _vm._v(" "), (atividade.expandir) ? _c('div', {
      staticClass: "itens_atividade",
      style: ('height: ' + (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 'px;' +
        'margin-top: ' + (_vm.configuracoes.altura + 2) + 'px;')
    }, _vm._l((atividade.itens), function(item) {
      return _c('div', [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm._.get(_vm.itemAtividadeEditando, 'id', 0) !== item.id),
          expression: "_.get(itemAtividadeEditando, 'id', 0) !== item.id"
        }, {
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: false,
            arrow: true,
            duration: 0,
            animation: 'fade',
            size: 'large',
            theme: 'light',
            placement: 'bottom',
            followCursor: true,
            distance: 40
          }),
          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
        }],
        class: 'truncar barra_item ' + ('' + item.origem === '2' ? 'item_contrapartida' : 'item_produto_servico'),
        style: ('width: ' + ((item.periodo_final - item.periodo_inicial + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
          'height: ' + (_vm.configuracoes.altura) + 'px;' +
          'margin-left: ' + ((item.periodo_inicial - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
          (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
          (_vm.modoEdicao ? 'cursor: pointer;' : '') +
          (item.valorSaldo <= 0 ? ('' + item.origem === '2' ? 'background: mediumseagreen;' : 'background: cornflowerblue;') : '') +
          'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
          'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;'),
        attrs: {
          "title": '<h5>' + item.fk_itens + ' - ' + item.observacao + '<br/><br/>' +
            'Orçado <b>' + (_vm.moeda(item.valorOrcado)) + '</b><br/><br/>' +
            'Saldo <b>' + (_vm.moeda(item.valorSaldo)) + '</b><br/><br/>' +
            '% liberado de <b>' + (_vm.percentual(item.valorOrcado - item.valorSaldo, item.valorOrcado)) + '%</b>' +
            '</h5>'
        },
        on: {
          "click": function($event) {
            _vm.itemAtividadeEditando = _vm.modoEdicao && atividade.executado < atividade.orcado ? _vm._.clone(item) : {}
          }
        }
      }, [_vm._v("\n\n                        " + _vm._s(item.fk_itens) + " - " + _vm._s(item.observacao) + "\n                      ")]), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.itemAtividadeEditando) && _vm.itemAtividadeEditando.id === item.id) ? _c('div', {
        staticClass: "slider_alteracao_item_atividade",
        style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
          'height: ' + (_vm.configuracoes.altura) + 'px;' +
          'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
      }, [_c('div', {
        staticClass: "barra_editando",
        style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
          'height: ' + (_vm.configuracoes.altura) + 'px;' +
          'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
      }), _vm._v(" "), _c('vue-slider', {
        attrs: {
          "lazy": true,
          "process": true,
          "adsorb": true,
          "enable-cross": false,
          "tooltip": 'always',
          "tooltip-formatter": function (periodo) { return _vm.periodoParaMesAno(periodo, _vm.projeto.inicio, 'MMMM/YYYY'); },
          "min": _vm.atividadeEditando.inicio,
          "max": _vm.atividadeEditando.termino
        },
        on: {
          "change": _vm.okAlteracaoItem
        },
        model: {
          value: (_vm.itemAtividadeEditando.periodo),
          callback: function($$v) {
            _vm.$set(_vm.itemAtividadeEditando, "periodo", $$v)
          },
          expression: "itemAtividadeEditando.periodo"
        }
      })], 1) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.atividadeEditando) && _vm.atividadeEditando.id === atividade.id) ? _c('div', {
      staticClass: "slider_alteracao_atividade",
      style: ('height: ' + (_vm.configuracoes.altura) + 'px;')
    }, [_c('div', {
      staticClass: "barra_editando",
      style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
        'height: ' + (_vm.configuracoes.altura) + 'px;' +
        'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
    }), _vm._v(" "), _c('vue-slider', {
      attrs: {
        "lazy": true,
        "process": false,
        "adsorb": true,
        "enable-cross": false,
        "tooltip": 'always',
        "tooltip-formatter": function (periodo) { return _vm.periodoParaMesAno(periodo, _vm.projeto.inicio, 'MMMM/YYYY'); },
        "min": 1,
        "max": _vm.projeto.periodos
      },
      on: {
        "change": _vm.okAlteracaoAtividade
      },
      model: {
        value: (_vm.atividadeEditando.periodo),
        callback: function($$v) {
          _vm.$set(_vm.atividadeEditando, "periodo", $$v)
        },
        expression: "atividadeEditando.periodo"
      }
    })], 1) : _vm._e()])
  }), 0)], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.mostrarLegenda && !_vm.loading.carregando) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "legenda_etiqueta realce"
  }, [_vm._v("Legendas")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#dfe4eb"
    },
    attrs: {
      "title": '<h5>Barra que representa o início e término da atividade do projeto</h5>'
    }
  }, [_vm._v("Atividade do projeto")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "var(--cor-destaque)"
    },
    attrs: {
      "title": '<h5>Esta cor na barra representa o percentual já liberado em recursos financeiros dos itens da atividade</h5>'
    }
  }, [_vm._v("Liberado")])])])]) : _vm._e(), _vm._v(" "), (_vm.modoEdicao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [(false && !_vm._.isNull(_vm.atividadeEditando)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row well well-sm no-shadow"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Atividade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.atividadeEditando.descricao))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Alterar período para:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('strong', [_vm._v(_vm._s(_vm.atividadeEditando.inicio))]), _vm._v(" até\n                  "), _c('strong', [_vm._v(_vm._s(_vm.atividadeEditando.termino))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.okAlteracaoAtividade
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelaAlteracao
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'justificativa')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row well well-sm no-shadow"
  }, [_c('div', {
    staticClass: "col-md-12 form-group required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.alteracao.justificativa),
      expression: "alteracao.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa",
      "placeholder": "Descreva justificativa",
      "rows": "3",
      "data-vv-as": "Justificativa"
    },
    domProps: {
      "value": (_vm.alteracao.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.alteracao, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-2 col-md-10"
  }, [(_vm.alteracao.alterados.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.alteracao.alterados.length))]), _vm._v(" atividades alteradas\n                  ")]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'opcoes') && !_vm.loading.carregando) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "opcoes",
    on: {
      "click": function($event) {
        _vm.configuracoes.mostrarOpcoes = !_vm.configuracoes.mostrarOpcoes;
        _vm.salvarConfiguracoes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Opções\n        ")]), _vm._v(" "), (_vm.editavel) ? _c('div', {
    staticClass: "opcoes",
    on: {
      "click": function($event) {
        return _vm.modoEdicaoEntrarSair(!_vm.modoEdicao)
      }
    }
  }, [_c('i', {
    class: 'fa fa-' + (!_vm.modoEdicao ? 'pencil-square-o' : 'eye')
  }), _vm._v(" " + _vm._s(!_vm.modoEdicao ? 'Editar' : 'Visualizar') + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.configuracoes.mostrarOpcoes),
      expression: "configuracoes.mostrarOpcoes"
    }],
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Zoom períodos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-slider', {
    attrs: {
      "min": 20,
      "max": 60,
      "interval": 1,
      "hide-label": true,
      "tooltip": 'none',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    scopedSlots: _vm._u([{
      key: "process",
      fn: function() {
        return [_c('div', {
          staticClass: "escalaZoom"
        })]
      },
      proxy: true
    }], null, false, 4023097680),
    model: {
      value: (_vm.configuracoes.larguraPadrao),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes, "larguraPadrao", $$v)
      },
      expression: "configuracoes.larguraPadrao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Altura da barra:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-slider', {
    attrs: {
      "data": [{
        tamanho: 10,
        nome: 'Estreita'
      }, {
        tamanho: 20,
        nome: 'Normal'
      }, {
        tamanho: 30,
        nome: 'Larga'
      }, {
        tamanho: 40,
        nome: 'Extra'
      }],
      "data-value": 'tamanho',
      "data-label": 'nome',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    model: {
      value: (_vm.configuracoes.altura),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes, "altura", $$v)
      },
      expression: "configuracoes.altura"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Largura do Cabeçalho:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-slider', {
    attrs: {
      "min": 0,
      "max": 600,
      "interval": 10,
      "hide-label": true,
      "tooltip": 'none',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    model: {
      value: (_vm.configuracoes.larguraCabecalho),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes, "larguraCabecalho", $$v)
      },
      expression: "configuracoes.larguraCabecalho"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Mostrar Grade:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarGrade),
      expression: "configuracoes.mostrarGrade"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarGrade"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarGrade, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarGrade", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarGrade),
      expression: "configuracoes.mostrarGrade"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarGrade"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarGrade, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarGrade", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [(_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > _vm.projeto.periodos) ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-exclamation-circle text-gray",
    attrs: {
      "title": '<h5>Já passou do término do projeto, por isso não mostra a marcação de ´hoje´ neste gráfico</h5>'
    }
  }) : _vm._e(), _vm._v("\n              Mostrar Hoje:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarHoje),
      expression: "configuracoes.mostrarHoje"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarHoje"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarHoje, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarHoje", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarHoje),
      expression: "configuracoes.mostrarHoje"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarHoje"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarHoje, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarHoje", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("\n              Mostrar Orçado Mensal:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarOrcadoMensal),
      expression: "configuracoes.mostrarOrcadoMensal"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarOrcadoMensal"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarOrcadoMensal, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarOrcadoMensal", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarOrcadoMensal),
      expression: "configuracoes.mostrarOrcadoMensal"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarOrcadoMensal"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarOrcadoMensal, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarOrcadoMensal", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.configuracoes.mostrarOrcadoMensal) ? _c('span', [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "margin": "0 20px"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarRecursoMensal),
      expression: "configuracoes.mostrarRecursoMensal"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarRecursoMensal"
    },
    domProps: {
      "value": [1],
      "checked": _vm._q(_vm.configuracoes.mostrarRecursoMensal, [1])
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarRecursoMensal", [1])
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" FBB "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarRecursoMensal),
      expression: "configuracoes.mostrarRecursoMensal"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarRecursoMensal"
    },
    domProps: {
      "value": [2],
      "checked": _vm._q(_vm.configuracoes.mostrarRecursoMensal, [2])
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarRecursoMensal", [2])
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Contrapartida "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat col-md-offset-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.configuracaoPadrao
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ao padrão")])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29569d75!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/GestaoAtividades.vue
// module id = 1897
// module chunks = 1